import { DataGrid } from "@mui/x-data-grid";
import "./table.scss";

export default function Table({ rows, columns }) {
  return (
    <div className="table" style={{ height: 600, width: "100%" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={9}
        rowsPerPageOptions={[9]}
        checkboxSelection
      />
    </div>
  );
}
